import React from 'react';
import {
  View, TouchableOpacity, StyleSheet, Dimensions, Platform, ViewStyle,
} from 'react-native';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
import ArrowDownIcon from '../../assets/icons/workout-history-header-icons/arrow-down.svg';
import ArrowUpIcon from '../../assets/icons/workout-history-header-icons/arrow-up.svg';

interface IconProps {
  color: string;
  width: number;
  height: number;
}

interface IArrowComponentProps {
  order: 'asc' | 'desc';
  color: string;
}

interface IProps {
  onPress: () => void;
  IconComponent: React.FC<IconProps>;
  isCurrentSortField: boolean;
  currentSortOrder: 'asc' | 'desc';
  cellStyle?: ViewStyle;
}

const Arrow: React.FC<IArrowComponentProps> = ({ order, color }) => {
  const arrowStyle = {
    width: defaultScale(7),
    height: defaultScale(7),
    color,
  };
  const wrapperStyle = {
    marginLeft: defaultScale(5),
  };

  return (
    <View style={wrapperStyle}>
      {order === 'desc' ? <ArrowDownIcon {...arrowStyle} /> : <ArrowUpIcon {...arrowStyle} />}
    </View>
  );
};

const { width } = Dimensions.get('window');
const isMobile = width <= 550;

const getIconSize = () => {
  if (Platform.OS === 'web') {
    return isMobile ? 25 : 30;
  }
  return 25;
};

const SortHeaderCell: React.FC<IProps> = ({
  onPress,
  IconComponent,
  isCurrentSortField,
  currentSortOrder,
  cellStyle,
}) => {
  const widthAndHeight = getIconSize();
  const activeColor = Theme.PRIMARY;
  const inactiveColor = Theme.BLACK;

  return (
    <View style={[styles.cell, cellStyle]}>
      <TouchableOpacity
        onPress={onPress}
        style={styles.buttonContainer}
      >
        <IconComponent
          color={isCurrentSortField ? activeColor : inactiveColor}
          width={widthAndHeight}
          height={widthAndHeight}
        />
        {isCurrentSortField
                    && <Arrow order={currentSortOrder} color={activeColor} />}
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  cell: {
    flex: 1,
    flexBasis: 0,
    paddingVertical: defaultScale(10),
    alignItems: 'center',
    justifyContent: 'center',
    borderRightColor: Theme.GREY_DARK_MEDIUM,
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default SortHeaderCell;
